<template>
    <el-pagination v-if="isShow" @current-change="onCurrentChange" :page-size="size" layout="total, prev, pager, next" :total="total"
    :current-page.sync="currentPage1">
    </el-pagination>
</template>
<script>
export default {
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
        size: {
            type: Number,
            default: 20
        },
        total: {
            type: Number,
            default: 0
        },
        page: {
           type: Number,
           default: 0
        }
    },
    computed: {
        currentPage1: {
            get() {
                return this.page;

            },
            set(v) {

            }
        }
    },
    methods: {
        onCurrentChange(page) {
            this.$emit('pageChange', page);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pagination/pagination.vue